import React, { memo, useState } from 'react';
import { Popover } from 'react-tiny-popover';

import css from './table.module.css';
import { TRow } from './types';

interface IProps {
  playerIndex: number;
  onChangeCell: React.Dispatch<React.SetStateAction<TRow[]>>;
  row: TRow;
}

export const TableCell = memo<IProps>(({ playerIndex, row, onChangeCell }) => {
  const [isTooltip, setIsTooltip] = useState(false);

  const playerData = row.players?.[`player_${playerIndex}`] || [];

  const handleCell = (clue: string | number) => {
    onChangeCell((prev) => {
      const rowIndex = prev.findIndex((item) => item.name === row.name);
      const newRows = [...prev];
      const newPlayer = { ...newRows[rowIndex] };

      if (typeof clue === 'number') {
        const numbers = playerData[1].split(',').map(Number).filter(Boolean);

        if (numbers.includes(clue)) {
          const newNumbers = numbers.filter((num) => num !== clue);
          newPlayer.players = {
            ...newPlayer.players,
            [`player_${playerIndex}`]: [playerData[0], newNumbers.join(',')],
          };
        } else {
          newPlayer.players = {
            ...newPlayer.players,
            [`player_${playerIndex}`]: [
              playerData[0],
              [...numbers, clue].sort((a, b) => a - b).join(','),
            ],
          };
        }
      } else {
        const newClue = playerData[0] === clue ? '' : clue;
        newPlayer.players = {
          ...newPlayer.players,
          [`player_${playerIndex}`]: [newClue, playerData[1]],
        };
      }

      newRows[rowIndex] = newPlayer;
      // save to local storage
      localStorage.setItem('rowData', JSON.stringify(newRows));
      return newRows;
    });

    setIsTooltip(false);
  };

  return (
    <Popover
      isOpen={isTooltip}
      positions={['top', 'bottom', 'left', 'right']} // preferred positions by priority
      content={
        <div className={css.tooltip}>
          <div className={css.clueBox}>
            {['!', '?', 'X', 'V'].map((clue) => (
              <span
                key={clue}
                className={css.clueSign}
                onClick={() => handleCell(clue)}
              >
                {clue}
              </span>
            ))}
          </div>
          <div className={css.clueBox}>
            {[1, 2, 3, 4, 5].map((num) => (
              <span
                key={num}
                className={css.clueSign}
                onClick={() => handleCell(num)}
              >
                {num}
              </span>
            ))}
          </div>
        </div>
      }
      onClickOutside={() => setIsTooltip(false)}
      reposition={true}
    >
      <td className={css.clue} onClick={() => setIsTooltip(true)}>
        <div className={css.clueContent}>
          <div className={css.clueSignText} data-clue={playerData[0]}>
            {playerData[0]}
          </div>
          <div className={css.clueNumbers}>{playerData[1]}</div>
        </div>
      </td>
    </Popover>
  );
});

TableCell.displayName = 'TableCell';
